import { render, staticRenderFns } from "./DialogEditTransfer.vue?vue&type=template&id=7c904b35"
import script from "./DialogEditTransfer.js?vue&type=script&lang=js&external"
export * from "./DialogEditTransfer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports